import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {QuestionnaireComponent} from './questionnaire/questionnaire.component';
import {HeaderComponent} from './header/header.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import { ModalComponent } from './modal/modal.component';
import {HttpClientModule} from '@angular/common/http';
// import { FinishComponent } from './finish/finish.component';
import {Module1Component} from './modules/module1/module1.component';
import {Module2Component} from './modules/module2/module2.component';
import {Module3Component} from './modules/module3/module3.component';
import {Module4Component} from './modules/module4/module4.component';
import {Module5Component} from './modules/module5/module5.component';
import {Module6Component} from './modules/module6/module6.component';
import {Module7Component} from './modules/module7/module7.component';
import {Module8Component} from './modules/module8/module8.component';
import {HomeComponent} from './home/home.component';

@NgModule({
    declarations: [
        AppComponent,
        QuestionnaireComponent,
        HeaderComponent,
        // ModalComponent,
        // FinishComponent,

        Module1Component,
        Module2Component,
        Module3Component,
        Module4Component,
        Module5Component,
        Module6Component,
        Module7Component,
        Module8Component,
        HomeComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatSliderModule,
        MatIconModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule
    ],
    providers: [],
    bootstrap: [AppComponent]
    // entryComponents: [ModalComponent]
})
export class AppModule {
}
